import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useStore } from '../../../../contexts/StoreContext';
import { TestIDs } from 'src/constants/testIDs.constants';
import BaseModal from '../../base-modal/BaseModal';
import { DynamicModalProps } from '../DynamicModal.types';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import { DYNAMIC_MODAL_ACTIONS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { useCallback } from 'react';
import { style } from './ModalNetwork.style';

export const ModalNetwork = observer(
  ({ type, dynamicModalVisible, dynamicModalLayer: { id, actionCallback } }: DynamicModalProps) => {
    const {
      i18n,
      dynamicModal: { closeModal },
    } = useStore();
    const onClose = useCallback(() => {
      closeModal();
      actionCallback(DYNAMIC_MODAL_ACTIONS.CLOSE);
    }, [closeModal, actionCallback]);

    return (
      <BaseModal
        testID={TestIDs.NETWORK}
        modalWidth={386}
        modalIcon={
          <View style={{ width: 64, height: 64 }}>
            <Illustration name={ILLUSTRATION_NAMES.NoWifi} />
          </View>
        }
        title={i18n.t('modal-network:title')}
        body={
          <View style={style.body}>
            <TextLato style={style.description}>{i18n.t('modal-network:description')}</TextLato>
            <View style={style.subDescription}>
              <TextLato style={style.description}>{i18n.t('modal-network:sub-description-head')}</TextLato>
              <TextLato style={[style.description, style.subDescriptionTail]}>
                {i18n.t('modal-network:sub-description-tail')}
              </TextLato>
            </View>
          </View>
        }
        confirmText={i18n.t('modal-network:cta')}
        handleConfirm={onClose}
        onCloseOutside={onClose}
        isVisible={dynamicModalVisible}
        type={type}
        id={id}
      />
    );
  },
);
